import api from '../../plugins/api';

const editComplectation = (id, params) => {
  return api.post('/api/crm/cars/editComplectation/'+id, params);
};

export default editComplectation;
